import React, { useEffect, useState } from "react";
import MainButton from "../../../components/button/mainButton";
import { TextBox, Input } from "../../../components/textfield";
import HeaderBar from "../../../components/header/headerBar";
import { useHistory, useParams, useLocation } from "react-router-dom";
import Icon from "@mdi/react";
import {
  mdiPlusCircle,
  mdiPrinter,
  mdiCloseCircle,
  mdiMinusCircle,
} from "@mdi/js";
import "../../../assets/styles/components/select.scss";
import "../../../assets/styles/admin/usedcourse.scss";
import EmptyModel from "../../../components/modal/emptyModal";
import { Table, TableColumn } from "../../../components/table";
import { Form, Select, Typography, message, DatePicker } from "antd";
import queryString from "query-string";
import axios from "axios";
import { format } from "date-fns";
import { numberWithCommas } from "../../../functions";

const dateFormat = "DD-MM-YYYY";
const { Option } = Select;
const { Title, Text } = Typography;
const data = [
  {
    id: "1",
    name: "Doctor(DF%)",
    storename: [],
  },
  {
    id: "2",
    name: "Nurse",
    storename: [],
  },
  {
    id: "3",
    name: "Therapist",
    storename: [],
  },
  {
    id: "4",
    name: "Therapist2",
    storename: [],
  },
  {
    id: "5",
    name: "คลีนหน้า/Clean",
    storename: [],
  },
  {
    id: "6",
    name: "แปะยาชา",
    storename: [],
  },
  {
    id: "7",
    name: "ล้างแผล/Dressing",
    storename: [],
  },
  {
    id: "8",
    name: "Anesthiologist(1=4800,15ml)...",
    storename: [],
  },
  {
    id: "9",
    name: "Assistant Anesth",
    storename: [],
  },
];

const messageText = "กรุณากรอกข้อมูล!";

interface ParamTypes {
  id?: string;
}

let initialValues = {
  memberCode: "",
  vn: "",
  amountUsed: "",
  dateUsed: "",
  memberCodeUsed: "",
  customerUsed: "",
  consultUsed: "",
  name: "",
  total: "0",
  balance: "0",
  courseCardId: "-",
  branch: "",
  priceUsed: "",
};

const CourseList1 = () => {
  const [form] = Form.useForm();
  const [formDialogOperator] = Form.useForm();
  const history = useHistory();
  const { id } = useParams<ParamTypes>();
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [selectedOperator, setSelectedOperator] = useState<any>({});
  const [state, setState] = useState<any>(data);
  const [selectNum, setSelectNum] = useState<number>(0);
  const [dataHead, setDataHead] = useState<any>({});
  const [branches, setBranches] = useState<any>([]);
  const [jobTitles, setJobTitles] = useState<any>([]);
  const [equipments, setEquipments] = useState<any>([]);
  const [originOperators, setOriginOperators] = useState<any>([]);
  const [operators, setOperators] = useState<any>([]);
  const [isSaveLoading, setIsSaveLoading] = useState<boolean>(false);
  const { search } = useLocation();
  const query = queryString.parse(search);
  const [course, setCourse] = useState<any>({
    coMembers: [],
    consults: [],
    item: {
      dateUsed: "",
      equipments: [],
    },
  });

  const headData = {
    CourseId: "R9-CNT61080007",
    Ref: "xxxxxx",
    Number: "30,000",
    Date: "2564-09-10",
    Customer: "R9-CNT61080007",
  };
  const nurse = [
    { value: "1", name: "นิมล วาสุทา1" },
    { value: "1", name: "นิมล วาสุทา2" },
    { value: "1", name: "นิมล วาสุทา3" },
  ];
  const columns = [
    {
      title: "ตำแหน่ง/Job Title",
    },
    {
      title: "ชื่อผู้ดำเนินการ/Operator",
    },
  ];

  const initData = async () => {
    getBranches();
    getEquipments();
    getOperators();
  };

  const getBranches = async () => {
    try {
      const branch = await axios.get(`/branches`);
      if (!branch?.data) return;
      setBranches(branch?.data?.data);
    } catch (err) {
      console.log("get data error =>", err);
    }
  };

  const getEquipments = async () => {
    try {
      // get medical equipments
      const equipments = await axios.get(`/medical-equipments`);
      if (!equipments?.data) return;
      setEquipments(equipments?.data?.data);
    } catch (err) {
      console.log("get data error =>", err);
    }
  };

  const getJobTitles = async ({ productCategoryId }: any = {}) => {
    console.log("productCategoryId =>", productCategoryId);

    try {
      const refJobGroup: any = await axios.get(
        `/job-groups?productCategoryId=${productCategoryId}`
      );
      if (!refJobGroup?.data) return;
      const dataJobTitles = refJobGroup.data?.data?.jobTitles?.map(
        (x: any) => ({
          ...x,
          operators: [],
        })
      );
      setJobTitles(dataJobTitles);
    } catch (err) {
      console.log("get data error =>", err);
    }
  };

  const getOperators = async () => {
    try {
      const operators = await axios.get(`/users`);
      if (!operators?.data) return;

      const oprs =
        operators?.data?.data?.map((x: any) => ({
          _id: x._id,
          displayName: `${x.prefix?.name} ${x.firstName} ${x.lastName}`,
        })) || [];
      setOperators(oprs);
      setOriginOperators(oprs);
    } catch (err) {
      console.log("get data error =>", err);
    }
  };

  const getData = async () => {
    // get data
    const { data } = await axios.get(
      `/use-courses/course-record/${id}?itemId=${query.itemId}`
    );
    if (!data) return;

    console.log("data =>", data);

    let i = 0;
    const euipments: any = {};
    for (const item of data.item?.equipments) {
      euipments[`equipment-${i}`] = "";
      euipments[`head-${i}`] = "";
      euipments[`amount-used-${i}`] = "";
      i++;
    }
    console.log("euipments =>", euipments);

    form.setFieldsValue({
      // ...data,
      memberCodeUsed: data.memberCode || "",
      vn: data.vn || "",
      name: data.item?.name || "",
      total: data.item?.formatTotal || "",
      balance: data.item?.formatBalance || "",
      courseCardId: "ST-6510030001" || "", // mock
      amountUsed: data?.item?.used || "",
      priceUsed:
        numberWithCommas(data.item?.priceUsed * data?.item?.used, 2) || "",
      ...euipments,
    });

    setCourse({ ...course, ...data });

    // set job titles

    getJobTitles({ productCategoryId: data.item?.productCategory });

    // setDataHead(headData);
  };

  function onClose() {
    setIsOpen(false);
  }

  function onClose2() {
    setIsOpen2(false);
  }

  function addOperator() {
    // const xOperator = state.OperatorTable;
    // console.log("X", xOperator);

    jobTitles[selectNum].operators.push(selectedOperator);
    jobTitles[selectNum].isInvalid = false;
    console.log("jobTitles check =>", jobTitles);
    setJobTitles([...jobTitles]);

    // setState({ ...state, state });
  }

  const removeOperator = (index1: any, index2: any) => {
    console.log("index", index1, index2);

    jobTitles[index1].operators.splice(index2, 1);
    jobTitles[index1].isInvalid = !jobTitles[index1].operators.length
      ? true
      : false;
    console.log("remove user in job titles =>", jobTitles);
    setState([...jobTitles]);
  };

  const onAddEquipment = () => {
    const newItem = {
      equipment: "",
      head: "",
      amountUsed: "",
      equipmentHeads: [],
    };
    const equipments = [...course.item.equipments];
    equipments.push(newItem);

    // set select equipment
    let i = 0;
    // const items: any = {};
    const quipmentNewItem: any = form.getFieldsValue();
    console.log("check quipmentNewItem before =>", quipmentNewItem);

    const index = equipments.length - 1;

    quipmentNewItem[`equipment-${index}`] = "";
    quipmentNewItem[`head-${index}`] = "";
    quipmentNewItem[`amount-used-${index}`] = "";

    form.setFieldsValue({ ...quipmentNewItem });

    setCourse({ ...course, item: { ...course.item, equipments } });
  };

  const onRemoveEquipment = ({ item, index }: any = {}) => {
    const equipments = [...course.item.equipments];

    // set old equipments
    let i = 0;
    const values: any = form.getFieldsValue();
    for (const item of equipments) {
      item.equipment = values[`equipment-${i}`];
      item.head = values[`head-${i}`];
      item.amountUsed = values[`amount-used-${i}`];
      i++;
    }

    console.log("equipments =>", equipments);
    equipments.splice(index, 1);
    console.log("equipments after =>", equipments);

    // set new equipments
    let i2 = 0;
    for (const item of equipments) {
      form.setFieldValue(`equipment-${i2}`, item.equipment || "");
      form.setFieldValue(`head-${i2}`, item.head || "");
      form.setFieldValue(`amount-used-${i2}`, item.amountUsed || "");
      i2++;
    }

    setCourse({ ...course, item: { ...course.item, equipments } });
  };

  const onSaveCourseRecord = async () => {
    setIsSaveLoading(true);

    const values: any = form.getFieldsValue();

    // equipments
    const equipments: any = [];
    let i = 0;
    for (const equipment of course.item?.equipments) {
      const item = {
        equipment: values[`equipment-${i}`],
        head: values[`head-${i}`],
        amountUsed: values[`amount-used-${i}`],
      };

      console.log("check item =>", item);

      equipments.push(item);
      i++;
    }

    // course records
    const _jobTitles: any = jobTitles.map((x: any) => ({
      jobTitle: x._id,
      operators: x.operators.map((y: any) => y._id),
    }));

    const data = {
      so: id || null,
      item: query.itemId || null,
      amountUsed: values.amountUsed || null,
      dateUsed: values.dateUsed || null,
      customerUsed: values.customerUsed || null,
      consultUsed: values.consultUsed || null,
      branch: values.branch || null,
      equipments,
      jobTitles: _jobTitles || [],
      courseCardId: values.courseCardId || null,
    };

    console.log("save data =>", data);

    try {
      const res: any = await axios.post(`/use-courses`, data);
      console.log("res =>", res);
    } catch (err) {
      console.log("err =>", err);

      message.error(
        "มีบางอย่างผิดพลาด! กรุณาลองใหม่อีกครั้งภายหลัง, There is something went wrong! please try again later."
      );
    }

    setTimeout(() => {
      setIsSaveLoading(false);
      console.log("course record have been saved.");
      history.push(`/usedcourse/${id}`);
      // setIsOpen2(false);
    }, 1000);
  };

  const checkValidate = async () => {
    const jobTitlesSelelted = await checkJobTitlesSelected({
      noMessage: false,
    });
    if (jobTitlesSelelted) {
      setIsOpen2(true);
    }
  };

  const checkJobTitlesSelected = async ({ noMessage = false }: any = {}) => {
    let countNoSelected = 0;
    const newJobTitles = [...jobTitles];
    for (const item of newJobTitles) {
      if (!item.operators.length) {
        countNoSelected++;
        item.isInvalid = true;
      }
    }

    setJobTitles(newJobTitles);

    if (countNoSelected && !noMessage) {
      message.warning(
        "ผู้ดำเนินการบางรายการยังไม่ถูกเลือก!, Some operators have not been selected!"
      );
      return false;
    }

    return true;
  };

  useEffect(() => {
    initData();
    getData();

    // console.log("search =>", search);
    // console.log("query =>", query);
  }, []);

  useEffect(() => {
    console.log("course change =>", course);
  }, [course]);

  const onAmountUsedChange = (e: any) => {
    const value = e.target.value;
    // console.log("value =>", value);

    console.log("priceUsed =>", course?.item?.priceUsed);

    form.setFieldValue(
      "priceUsed",
      numberWithCommas(value * course?.item?.priceUsed, 2)
    );
  };

  return (
    <div>
      <HeaderBar title={`Course Record / ${course?.item?.name}`} btnBack />
      {/* <ConFirmModal type={1} show={showModal1} onClose={toggleModal1} /> */}

      <EmptyModel show={isOpen} onClose={onClose} width="40%">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "20px 20px",
          }}
        >
          <h5>เลือกชื่อผู้ดำเนินการ/Select Operator</h5>

          <Form
            form={formDialogOperator}
            initialValues={{ operator: "" }}
            layout="vertical"
            onFinish={(values: any) => {
              console.log("finish =>", values);

              addOperator();
              setIsOpen(false);
            }}
          >
            <div className="row justify-center mt-40">
              <Title className="col-12" level={5} style={{ color: "#4D7E7F" }}>
                ชื่อผู้ดำเนินการ/Operator
              </Title>
              <div className="col-12">
                <Form.Item
                  name="operator"
                  rules={[
                    {
                      required: true,
                      message: messageText,
                    },
                  ]}
                >
                  <Select
                    showSearch
                    filterOption={(input, option) =>
                      (option!.children as unknown as string)
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    id="select"
                    // defaultValue="กรุณาเลือกชื่อ"
                    // style={{ width: "100%" }}
                    onChange={(value) => {
                      console.log("value =>", value);

                      const obj = operators.find(
                        (x: any) => x._id?.toString() === value?.toString()
                      );

                      console.log("obj =>", obj);

                      setSelectedOperator(obj);
                    }}
                  >
                    {operators.map((item: any, i: number) => (
                      <Option value={item._id} key={i}>
                        {item.displayName}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
            </div>

            <div className="justify-center mt-40">
              <MainButton
                className="mg-10"
                background="#E76464"
                title="ยกเลิก"
                onClick={() => {
                  setIsOpen(false);
                }}
              />
              <MainButton
                className="mg-10"
                background="#4D7E7F"
                title="ยืนยัน"
                onClick={() => {
                  formDialogOperator.submit();
                  //console.log("");
                  // const values: any = formDialogOperator.getFieldsValue();
                  // if (!values.operator) {
                  //   message.warning(
                  //     "กรุณาเลือกชื่อผู้ดำเนินการ!/Please select operator name!"
                  //   );
                  //   return;
                  // }
                  // addOperator();
                  // setIsOpen(false);
                }}
              />
            </div>
          </Form>
        </div>
      </EmptyModel>

      <EmptyModel show={isOpen2} onClose={onClose2} width="40%">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "40px 20px",
          }}
        >
          <h4 className="mb-10">Date Used</h4>
          <div className="row justify-center">
            {format(new Date(), "dd-MM-yyyy")}
          </div>
          <div className="row justify-center">
            ({format(new Date(), "dd MMMM yyyy")})
          </div>
          {/* <div className="row justify-center">
            {format(new Date(), "HH : mm aaa")}
          </div> */}
          <div className="justify-center mt-20">
            <MainButton
              className="mg-10"
              background="#E76464"
              title="ยกเลิก"
              onClick={() => {
                setIsOpen2(false);
              }}
            />
            <MainButton
              className="mg-10"
              background="#4D7E7F"
              title="ยืนยัน"
              loading={isSaveLoading}
              onClick={() => onSaveCourseRecord()}
            />
          </div>
        </div>
      </EmptyModel>

      <Form
        form={form}
        name="basic"
        className="form-primary"
        // labelCol={{ span: 8 }}
        // wrapperCol={{ span: 16 }}
        initialValues={{ ...initialValues }}
        onFinish={checkValidate}
        onFinishFailed={async () => {
          const jobTitlesSelelted = await checkJobTitlesSelected({
            noMessage: true,
          });

          message.warning(
            "กรุณาป้อนข้อมูลให้ครบถ้วน!, Please enter complete information!"
          );
        }}
      >
        <div className="row" style={{ padding: "20px 20px" }}>
          <div style={{ marginTop: "20px" }}>
            <div className="container justify-content-space-between">
              <div className="row space-between">
                <div
                  className="card col-6"
                  style={{ width: "calc(50% - 5px)" }}
                >
                  <div className="card-body">
                    <div className="row mt-20">
                      <div className="col-12">
                        <Form.Item
                          name="name"
                          rules={[
                            {
                              required: false,
                              message: messageText,
                            },
                          ]}
                        >
                          <Input title="หัตถการ/Treatment" disabled={true} />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="row mt-20">
                      {course.itemType === "treatment" ? (
                        <>
                          <div className="col-6">
                            <Form.Item
                              name="total"
                              rules={[
                                {
                                  required: false,
                                  message: messageText,
                                },
                              ]}
                            >
                              <Input
                                title="รวม/Total"
                                disabled={true}
                                inputClassName="align-right"
                              />
                            </Form.Item>
                          </div>
                          <div className="col-6">
                            <Form.Item
                              name="balance"
                              rules={[
                                {
                                  required: false,
                                  message: messageText,
                                },
                              ]}
                            >
                              <Input
                                title="คงเหลือ/Balance"
                                disabled={true}
                                inputClassName="align-right"
                              />
                            </Form.Item>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="col-6">
                            <Form.Item
                              name="balance"
                              rules={[
                                {
                                  required: false,
                                  message: messageText,
                                },
                              ]}
                            >
                              <Input
                                title="คงเหลือ/Balance"
                                disabled={true}
                                inputClassName="align-right"
                              />
                            </Form.Item>
                          </div>
                          <div className="col-6">
                            <Text style={{ color: "#5BAEA9", fontSize: 14 }}>
                              {"วันที่ใช้/Date Used"}
                            </Text>
                            <Form.Item
                              name="dateUsed"
                              rules={[
                                {
                                  required: true,
                                  message: messageText,
                                },
                              ]}
                            >
                              <DatePicker
                                // placeholder="วันที่ใช้/Date Used"
                                format={dateFormat}
                                // style={{
                                //   height: "auto",
                                //   width: "100%",
                                //   border: "none",
                                //   borderRadius: "0px",
                                //   borderBottom: "2px solid #d9d9d9",
                                // }}
                                // disabledDate={disableDatePicker}
                                onChange={(e: any) => {
                                  // if (e !== null) {
                                  //   setDisabledDate(false);
                                  // } else {
                                  //   setDisabledDate(true);
                                  // }
                                  // formCreateGift.setFieldsValue({
                                  //   quantityMonth: "",
                                  //   endDate: "",
                                  // });
                                }}
                              />
                            </Form.Item>
                          </div>
                        </>
                      )}
                    </div>
                    <div className="row mt-20">
                      <div className="col-6">
                        <Form.Item
                          name="amountUsed"
                          rules={[
                            {
                              validator: async (_, value) => {
                                // console.log("value =>", value);

                                const isNumber = !isNaN(value);

                                console.log("check course =>", course);

                                if (!value) {
                                  return Promise.reject(new Error(messageText));
                                } else if (!isNumber) {
                                  return Promise.reject(
                                    new Error("กรุณาป้อนตัวเลข!")
                                  );
                                } else if (course?.itemType === "treatment") {
                                  if (value > course.item?.balance) {
                                    return Promise.reject(
                                      new Error(
                                        "กรุณาป้อนไม่เกินจากจำนวนคงเหลือ!"
                                      )
                                    );
                                  }
                                } else if (
                                  course?.item?.promotionType === "package"
                                ) {
                                  console.log("this is package check value...");

                                  if (value > course.item?.balance) {
                                    return Promise.reject(
                                      new Error(
                                        "กรุณาป้อนไม่เกินจากจำนวนคงเหลือ!"
                                      )
                                    );
                                  }
                                } else if (course?.itemType === "promotion") {
                                  const totalPriceUsed =
                                    value * course?.item?.priceUsed;
                                  // console.log(
                                  //   "totalPriceUsed =>",
                                  //   totalPriceUsed
                                  // );

                                  if (totalPriceUsed > course?.item?.balance) {
                                    return Promise.reject(
                                      new Error(
                                        "กรุณาป้อนไม่เกินจากจำนวนคงเหลือ!"
                                      )
                                    );
                                  }
                                }
                              },
                            },
                          ]}
                        >
                          <Input
                            title="จำนวนที่จะใช้/Amount Used"
                            inputClassName="align-right"
                            placeholder="0"
                            onChange={onAmountUsedChange}
                          />
                        </Form.Item>
                      </div>

                      {course.itemType === "treatment" ? (
                        <>
                          <div className="col-6">
                            <Text style={{ color: "#5BAEA9", fontSize: 14 }}>
                              {"วันที่ใช้/Date Used"}
                            </Text>
                            <Form.Item
                              name="dateUsed"
                              rules={[
                                {
                                  required: true,
                                  message: messageText,
                                },
                              ]}
                            >
                              <DatePicker
                                // placeholder="วันที่ใช้/Date Used"
                                format={dateFormat}
                                // style={{
                                //   height: "auto",
                                //   width: "100%",
                                //   border: "none",
                                //   borderRadius: "0px",
                                //   borderBottom: "2px solid #d9d9d9",
                                // }}
                                // disabledDate={disableDatePicker}
                                onChange={(e: any) => {
                                  // if (e !== null) {
                                  //   setDisabledDate(false);
                                  // } else {
                                  //   setDisabledDate(true);
                                  // }
                                  // formCreateGift.setFieldsValue({
                                  //   quantityMonth: "",
                                  //   endDate: "",
                                  // });
                                }}
                              />
                            </Form.Item>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="col-6">
                            <Form.Item
                              name="priceUsed"
                              rules={[
                                {
                                  required: false,
                                  message: messageText,
                                },
                              ]}
                            >
                              <Input
                                title="รวมราคาที่ใช้/Total Price Use"
                                disabled={true}
                                inputStyle={{ textAlign: "right" }}
                              />
                            </Form.Item>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <div
                  className="card col-6"
                  style={{ width: "calc(50% - 5px)" }}
                >
                  <div className="card-body">
                    <div className="row mt-20">
                      <div className="col-6">
                        <Form.Item
                          name="courseCardId"
                          rules={[
                            {
                              required: true,
                              message: messageText,
                            },
                          ]}
                        >
                          <Input
                            title="เลขที่บัตรคอร์ส/Course Card ID"
                            disabled={true}
                          />
                        </Form.Item>
                      </div>
                      <div className="col-6">
                        <Form.Item
                          name="vn"
                          rules={[
                            {
                              required: true,
                              message: messageText,
                            },
                          ]}
                        >
                          <Input title="เลขที่ใบยา/Ref" disabled={true} />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="row mt-20">
                      <div className="col-6">
                        <Form.Item
                          name="memberCodeUsed"
                          rules={[
                            {
                              required: true,
                              message: messageText,
                            },
                          ]}
                        >
                          <Input title="รหัสลูกค้า/CN" disabled={true} />
                        </Form.Item>
                      </div>

                      <div className="col-6">
                        <Text style={{ color: "#5BAEA9", fontSize: 14 }}>
                          {"ผู้ใช้/Customer"}
                        </Text>
                        <Form.Item
                          name="customerUsed"
                          rules={[
                            {
                              required: true,
                              message: messageText,
                            },
                          ]}
                        >
                          <Select
                            // defaultValue="กรุณาเลือกชื่อ"
                            // style={{ width: 225, fontSize: 18 }}
                            // onChange={handleChange}
                            onChange={(value) => {
                              console.log("on change =>", value);
                              // setCourse({
                              //   ...course,
                              //   item: { ...course.item, customerUsed: value },
                              // });
                            }}
                          >
                            {course.coMembers.map((item: any, i: number) => (
                              <Option value={item._id} key={i}>
                                {item.displayName}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                    <div className="row mt-20">
                      <div className="col-6">
                        <Text style={{ color: "#5BAEA9", fontSize: 14 }}>
                          {"ผู้ดูแล/Consult"}
                        </Text>
                        <Form.Item
                          name="consultUsed"
                          rules={[
                            {
                              required: true,
                              message: messageText,
                            },
                          ]}
                        >
                          <Select
                            // defaultValue={""}
                            // style={{ width: 225, fontSize: 18 }}
                            onChange={(value) => {
                              console.log("on change =>", value);
                              // setCourse({
                              //   ...course,
                              //   item: { ...course.item, consultUsed: value },
                              // });
                            }}
                          >
                            {course.consults.map((item: any, i: number) => (
                              <Option value={item._id} key={i}>
                                {item.displayName}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>

                      <div className="col-6">
                        <Text style={{ color: "#5BAEA9", fontSize: 14 }}>
                          {"สาขา/Branch"}
                        </Text>
                        <Form.Item
                          name="branch"
                          rules={[
                            {
                              required: true,
                              message: messageText,
                            },
                          ]}
                        >
                          <Select
                            // defaultValue="สาขา"
                            // style={{ width: 225, fontSize: 18 }}
                            onChange={(value) => {
                              console.log("on change =>", value);
                              // setCourse({
                              //   ...course,
                              //   item: { ...course.item, branch: value },
                              // });
                            }}
                          >
                            {branches.map((item: any, i: number) => (
                              <Option value={item._id} key={i}>
                                {item.name}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style={{ marginTop: "20px" }}>
            <div className="container justify-content-space-between">
              <div className="row justify-content-center">
                <div className="card col-12">
                  <div className="card-body">
                    {course.item?.equipments?.map(
                      (item: any, index: number) => (
                        <div className="row mt-20" key={index}>
                          <div className="col-11">
                            <div className="row">
                              <div className="col-4">
                                <Text
                                  style={{ color: "#5BAEA9", fontSize: 14 }}
                                >
                                  {`เครื่องมือที่ใช้ (${
                                    index + 1
                                  })/Equipment (${index + 1})`}
                                </Text>
                                <Form.Item
                                  name={`equipment-${index}`}
                                  // rules={[{ required: true, message: "Please input your password!" }]}
                                  rules={[
                                    {
                                      required: true,
                                      message: messageText,
                                    },
                                  ]}
                                >
                                  <Select
                                    // defaultValue="กรุณาเลือกชื่อ"
                                    // defaultValue={
                                    //   course.item?.equipments[index]
                                    //     ?.equipment || ""
                                    // }
                                    // style={{ width: 225, fontSize: 18 }}
                                    // onChange={handleChange}
                                    onChange={async (value) => {
                                      console.log("on change =>", value);
                                      const equipments = [
                                        ...course.item?.equipments,
                                      ];
                                      equipments[index].equipment = value;
                                      // get data heads
                                      try {
                                        const { data } = await axios.get(
                                          `medical-equipment-heads?equipmentId=${value}`
                                        );
                                        if (!data) return;
                                        console.log("data heads =>", data.data);
                                        equipments[index].equipmentHeads =
                                          data.data;
                                      } catch (err) {
                                        console.log("get heads error =>", err);
                                      }
                                      setCourse({
                                        ...course,
                                        item: { ...course.item, equipments },
                                      });
                                      // set head value to null
                                      equipments[index].head = null;
                                      form.setFieldValue(`head-${index}`, null);
                                    }}
                                  >
                                    {equipments.map((item: any, i: number) => (
                                      <Option value={item._id} key={i}>
                                        {item.name}
                                      </Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                              </div>
                              <div className="col-4">
                                <Text
                                  style={{ color: "#5BAEA9", fontSize: 14 }}
                                >
                                  {"หัวที่ใช้/Head"}
                                </Text>
                                <Form.Item
                                  name={`head-${index}`}
                                  rules={[
                                    {
                                      required: true,
                                      message: messageText,
                                    },
                                  ]}
                                >
                                  <Select
                                    // defaultValue="กรุณาเลือกชื่อ"
                                    // defaultValue={
                                    //   course.item?.equipments[index]?.head || ""
                                    // }
                                    // style={{ width: 225, fontSize: 18 }}
                                    // onChange={handleChange}
                                    onChange={(value) => {
                                      console.log("on change =>", value);
                                      const equipments = [
                                        ...course.item?.equipments,
                                      ];
                                      equipments[index].head = value;
                                      setCourse({
                                        ...course,
                                        item: { ...course.item, equipments },
                                      });
                                    }}
                                  >
                                    {course.item.equipments[
                                      index
                                    ].equipmentHeads.map(
                                      (item: any, i: number) => (
                                        <Option value={item._id} key={i}>
                                          {item.name}
                                        </Option>
                                      )
                                    )}
                                  </Select>
                                </Form.Item>
                              </div>
                              <div className="col-4">
                                <Form.Item
                                  name={`amount-used-${index}`}
                                  rules={[
                                    {
                                      required: true,
                                      message: messageText,
                                    },
                                  ]}
                                >
                                  <Input
                                    title="จำนวนที่ใช้ (Shot/นาที)/Amount Used(Shot/min)"
                                    placeholder="0"
                                    inputClassName="align-right"
                                    // value={
                                    //   course.item?.equipments[index]
                                    //     ?.amountUsed || ""
                                    // }
                                    // onBlur={(e: any) => {
                                    //   setCreditPrices(Number(e.target.value).toFixed(2));
                                    // }}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      console.log("value =>", value);
                                      // const equipments = [
                                      //   ...course.item?.equipments,
                                      // ];
                                      // equipments[index].amountUsed = value;
                                      // setCourse({
                                      //   ...course,
                                      //   item: { ...course.item, equipments },
                                      // });
                                      // setCreditPrices(e.target.value);
                                    }}
                                  />
                                </Form.Item>
                              </div>
                            </div>
                          </div>
                          <div
                            className="col-1"
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            {course.item?.equipments?.length > 1 ? (
                              <a
                                onClick={() =>
                                  onRemoveEquipment({ item, index })
                                }
                              >
                                <Icon
                                  path={mdiMinusCircle}
                                  size="27"
                                  color="#E76464"
                                />
                              </a>
                            ) : (
                              <Icon
                                path={mdiMinusCircle}
                                size="27"
                                color="#ccc"
                              />
                            )}
                          </div>
                        </div>
                      )
                    )}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        justifyItems: "center",
                        marginTop: "20px",
                      }}
                    >
                      <div>
                        <span style={{ marginRight: "7px" }}>
                          เพิ่มเครื่องมือที่ใช้/Add Equipment
                        </span>{" "}
                        <a onClick={() => onAddEquipment()}>
                          <Icon
                            path={mdiPlusCircle}
                            size="27"
                            color="#4D7E7F"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style={{ marginTop: "50px" }}>
            <div className="container">
              <Table header={columns}>
                {jobTitles.map((item: any, index: any) => (
                  <tr
                    key={index}
                    // onClick={() => history.push(`/usedcourse/${item.SO}`)}
                    style={{ cursor: "pointer" }}
                  >
                    <TableColumn width="50%">
                      {index + 1}. {item.name}
                    </TableColumn>
                    <TableColumn width="50%">
                      <div
                        className="font-text-value"
                        style={{
                          display: "flex",
                          justifyContent: "left",
                        }}
                      ></div>

                      <div className="d-flex justify-content-between ">
                        <div>
                          {item.isInvalid ? (
                            <div style={{ color: "#ff4d4f" }}>
                              {messageText}
                            </div>
                          ) : (
                            item.operators.map((itm: any, in2: number) => (
                              <span
                                onClick={() => removeOperator(index, in2)}
                                key={in2}
                              >
                                {itm.displayName}
                                <Icon
                                  path={mdiCloseCircle}
                                  size="24"
                                  color="#E76464"
                                />
                              </span>
                            ))
                          )}
                        </div>
                        <div
                          className="font-text-value"
                          style={{
                            display: "flex",
                            justifyContent: "right",
                          }}
                        >
                          {item.operators.length < 2 && (
                            <div
                              onClick={() => {
                                setSelectNum(index);
                                //addOperator(index);

                                const jobTitle = jobTitles[index];

                                // console.log("jobTitle test =>", jobTitle);

                                const filters = originOperators.filter(
                                  (x: any) =>
                                    x._id.toString() !==
                                    jobTitle.operators
                                      .find(
                                        (y: any) =>
                                          y._id.toString() === x._id.toString()
                                      )
                                      ?._id?.toString()
                                );
                                console.log("filters =>", filters);

                                setOperators([...filters]);

                                // clear form dialog
                                formDialogOperator.setFieldsValue({
                                  operator: "",
                                });

                                setIsOpen(true);
                              }}
                            >
                              <Icon
                                path={mdiPlusCircle}
                                size="27"
                                color="#4D7E7F"
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </TableColumn>
                  </tr>
                ))}
              </Table>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "20px",
              }}
            >
              {/* <MainButton
                title="ย้อนกลับ"
                background="#E76464"
                className="mg-10"
                onClick={() => history.push(`/usedcourse/1`)}
              /> */}
              <MainButton
                title="พิมพ์ใบเซ็น/Print Signature"
                background="#4285F4"
                className="mg-10"
              >
                <Icon path={mdiPrinter} size="20" color="#fff" />
              </MainButton>
              <MainButton
                title="พิมพ์ใบยา/Print Medicine"
                background="#4285F4"
                className="mg-10"
              >
                <Icon path={mdiPrinter} size="20" color="#fff" />
              </MainButton>
              <MainButton
                title="ยืนยัน/Confirm"
                background="#4D7E7F"
                className="mg-10"
                onClick={() => {
                  console.log("submiting...");

                  form.submit();

                  // console.log("is valid form.");

                  // setIsOpen2(true);
                }}
              />
            </div>
          </div>
        </div>
      </Form>
    </div>
  );
};
export default CourseList1;
